import { render, staticRenderFns } from "./GraficaDos.vue?vue&type=template&id=52b9aa19&scoped=true&"
import script from "./GraficaDos.vue?vue&type=script&lang=js&"
export * from "./GraficaDos.vue?vue&type=script&lang=js&"
import style0 from "./GraficaDos.vue?vue&type=style&index=0&id=52b9aa19&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52b9aa19",
  null
  
)

export default component.exports